import "_api/bbs/post-article/web";
import { articlePlugin, Article } from '../../core/Article';
import { HbToast } from '@heybox-components/heybox-ui'
import { formatWebpParams, executeProtocolOutApp } from '_lib/utils'
import HbImgDirective from '../../directives/v-hb-img'

export const HbArticle = {
  install (Vue) {
    Vue.use(articlePlugin)
    Vue.component('hb-article', require('./hb-article.vue').default)
    Vue.prototype.$hb_toast= hb_toast
  }
}

const hb_toast = {
  success (msg) {
    HbToast.tip({
      text: msg
    })
  },
  failed (msg) {
    HbToast.warning({
      text: msg
    })
  },
  confirm (msg, confirm, cancel) {
    return Promise.resolve()
  }
}

// 构造$hb_tools，与app内部部分同步
const tools = {
  encodeHbImgUri (url) {
    return formatWebpParams(url)
  },
  linkToUserPage (id) {
    executeProtocolOutApp({
      "protocol_type": "openUser",
      "user_id": id
    })
  }
}

const articlePlatformPlugin = {
  install (Vue) {
    Vue.use(articlePlugin)
    Vue.use(HbImgDirective)
    Vue.prototype.$hb_toast= hb_toast
    Vue.prototype.$hb_tools = tools
    
  }
}


export {
  articlePlatformPlugin,
  Article
}